import { API_ORGANIZATION_PREFIX } from '@shared/config/api/api-prefixes';
import { OrganizationLockDataRequest, OrganizationLockDataResponse } from './organization-lock-types';
import { organizationApi } from '@entities/organization/api/organization-api';

export const organizationLockApi = organizationApi.injectEndpoints({
    endpoints: (build) => ({
        organizationLock: build.mutation<OrganizationLockDataResponse, OrganizationLockDataRequest>({
            query: (data) => {
                return {
                    url: `${API_ORGANIZATION_PREFIX}/${data.id}/active`,
                    method: 'PATCH',
                    body: data,
                };
            },
        }),
    }),
});

export const { useOrganizationLockMutation } = organizationLockApi;
